import axios from 'axios';
import {
	req,
	reqF,
} from './axiosFun';

/**角色接口**/
// 获取角色列表
export const getRoleListForPage = (params) => {
	return reqF("post", "/api/sysConfig/Role/GetRoleListForPage", params)
};
// 保存角色信息
export const SaveRoleInfo = (params) => {
	return reqF("post", "/api/sysConfig/Role/SaveRoleInfo", params)
};
// 获取角色信息详情
export const GetRoleInfoDetail = (params) => {
	return reqF("post", "/api/sysConfig/Role/GetRoleInfoDetail", params)
};
// 删除角色信息
export const DeleteRoleInfo = (params) => {
	return reqF("post", "/api/sysConfig/Role/DeleteRoleInfo", params)
};
// 获取角色关联的人员名单
export const GetRoleLinkUserList = (params) => {
	return reqF("post", "/api/sysConfig/Role/GetRoleLinkUserList", params)
};
// 获取未关联角色的用户列表
export const GetUnLinkUserList = (params) => {
	return reqF("post", "/api/sysConfig/Role/GetUnLinkUserList", params)
};
// 保存角色关联的用户信息
export const SaveRoleLinkUser = (params) => {
	return reqF("post", "/api/sysConfig/Role/SaveRoleLinkUser", params)
};

// 角色绑定下拉框
export const GetRoleDropList = (params) => {
	return reqF("post", "/api/sysConfig/Role/GetRoleDropList", params)
};



/**人员接口**/
// 获取用户分页列表
export const GetUserListForPage = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserListForPage", params)
};

// 删除用户信息
export const DeleteUserInfo = (params) => {
	return reqF("post", "/api/sysConfig/User/DeleteUserInfo", params)
};

// 保存用户信息
export const SaveUserInfo = (params) => {
	return reqF("post", "/api/sysConfig/User/SaveUserInfo", params)
};

// 获取用户详细信息
export const GetUserInfoDetail = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserInfoDetail", params)
};

// 获取用户基础详细信息
export const GetUserSingleDetail = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserSingleDetail", params)
};

// 修改人员照片
export const UpdateUserPhoto = (params) => {
	return reqF("post", "/api/sysConfig/User/UpdateUserPhoto", params)
};

// 修改人员签字图片
export const UpdateUserSignature = (params) => {
	return reqF("post", "/api/sysConfig/User/UpdateUserSignature", params)
};

// 获取人员信息绑定下拉框_根据权限
export const GetUserBindSelectByPermission = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserBindSelectByPermission", params)
};
// 获取人员信息绑定下拉框_姓名【用户名】
export const GetUserInfoDropList = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserInfoDropList", params)
};

// 获取人员全量信息绑定下拉框
export const GetUserInfoSimpleDropList = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserInfoSimpleDropList", params)
};

// 获取部门/班组关联的人员填充下拉框
export const GetUserInfoBindSelectByDept = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserInfoBindSelectByDept", params)
};

// 获取组织架构关联的人员填充下拉框
export const GetUserInfoBindSelectByOrganization = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserInfoBindSelectByOrganization", params)
};

// 人员信息导出
export const GetUserInfoExport = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserInfoExport", params)
};

// 分页获取焊工列表
export const GetWelderList = (params) => {
	return reqF("post", "/api/sysConfig/User/GetWelderList", params)
};

// 焊工下拉列表
export const GetWelderDropDownList = (params) => {
	return reqF("post", "/api/sysConfig/User/GetWelderDropDownList", params)
};

// 根据部门获取人员信息
export const GetUserInfoByDept = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserInfoByDept", params)
};

// 获取角色关联的人员填充下拉框
export const GetUserInfoBindSelectByRole = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserInfoBindSelectByRole", params)
};
// 获取多个角色关联的人员填充下拉框
export const GetUserInfoBindSelectByRoleList = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserInfoBindSelectByRoleList", params)
};

// 获取人员信息绑定下拉框
export const GetUserInfoBindSelect = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserInfoBindSelect", params)
};

// 获取部门关联的人员填充下拉框
export const GetUserBindSelectByDept = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserBindSelectByDept", params)
};

// 更新用户手机号
export const UpdateUserPhone = (params) => {
	return reqF("post", "/api/sysConfig/User/UpdateUserPhone", params)
};

// 修改密码
export const UpdatePassWord = (params) => {
	return reqF("post", "/api/sysConfig/User/UpdatePassWord", params)
};

// 重置密码
export const ResetPwd = (params) => {
	return reqF("post", "/api/sysConfig/User/ResetPwd", params)
};

// 获取人员资质信息数据列表
export const GetUserQualificationList = (params) => {
	return reqF("post", "/api/sysConfig/QualificationInfo/GetUserQualificationList", params)
};


// 获取人员登录日志列表
export const GetUserLoginLogList = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserLoginLogList", params)
};
// 获取人员登录日志统计信息
export const GetUserLoginLogStatistic = (params) => {
	return reqF("post", "/api/sysConfig/User/GetUserLoginLogStatistic", params)
};